import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Slide from '@material-ui/core/Slide'
import { HowIcon } from '../app-icon/Icons'
import DSView from '../articles/DSView'
import Wrapper from '../wrapper'
import LogoHelpData from '../app-logo/logo-help'

const styles = {
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(136, 102, 255)',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  icon: {
    padding: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 16px 32px 0 rgba(0, 0, 0, 0.12)',
    backgroundColor: 'rgb(255, 204, 0)',
    borderRadius: '100%',
    marginRight: 15,
  },
  paper: { backgroundColor: '#ffcc00' },
}

function Transition(props) {
  return <Slide direction="up" {...props} />
}

class HowToCreateViewDialog extends React.Component {
  state = {
    open: false,
  }

  handleClickOpen = event => {
    event.preventDefault()
    this.setState({ open: true })
  }

  handleClose = () => {
    this.setState({ open: false })
  }
  render() {
    return (
      <div>
        <a
          href=""
          className={this.props.classes.link}
          onClick={this.handleClickOpen}
        >
          <span className={this.props.classes.icon}>
            <HowIcon />
          </span>
          Как создать представление в Google Analytics
        </a>
        <Dialog
          fullScreen
          open={this.state.open}
          onClose={this.handleClose}
          TransitionComponent={Transition}
          PaperProps={{
            classes: {
              root: this.props.classes.paper,
            },
          }}
        >
          <AppBar className={this.props.classes.appBar} elevation={0}>
            <Toolbar style={{ paddingTop: 16 }}>
              <LogoHelpData />
              <IconButton
                color="inherit"
                onClick={this.handleClose}
                aria-label="Close"
                style={{ marginLeft: 'auto' }}
              >
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <div
            style={{
              margin: 30,
            }}
          >
            <Wrapper
              shadow={4}
              style={{
                maxWidth: 800,
                margin: '0 auto',
                borderRadius: 32,
                overflow: 'hidden',
                padding: '1rem 2rem',
                backgroundColor: 'rgb(255, 255, 255)',
                fontFamily: '"Exo 2", "Helvetica", "Arial", sans-serif',
                lineHeight: 1.5,
              }}
            >
              <DSView />
            </Wrapper>
          </div>
        </Dialog>
      </div>
    )
  }
}

export default withStyles(styles)(HowToCreateViewDialog)
